import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import {
  getFcmTokenForApp,
  registerMessagingServiceWorker,
} from "utils/firebaseMessaging";

const app = initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  publickey: process.env.REACT_APP_FIREBASE_PUBLIC_KEY,
});

export const auth = getAuth(app);
export const db = getFirestore(app);

/**
 * Returns the web FCM token after permission + service-worker registration.
 * Empty string when unsupported, denied, or token retrieval fails.
 *
 * @returns {Promise<string>}
 */
export const getFCMToken = async () => {
  try {
    return await getFcmTokenForApp(app);
  } catch (error) {
    console.error("Error getting FCM token:", error);
    return "";
  }
};

registerMessagingServiceWorker();

export default app;
